import { Slide } from "@jelly/lesson";
import config from "appConfig";
import theory from "../../theory";

const principle: Slide = {
  title: "Airborne sound insulation - Levels in the receiving room",
  description:
    "Levels in the receiving room with background noise and correction due to influence of background noise.",
  theory: theory,
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "blockContainer",
        data: {
          block: {
            type: "image",
            options: {
              src: `${config.ASSETS_URL}/05/22/principle/principle-4.svg`,
            },
          },
        },
      },
    },
  },
};

export default principle;
